var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigOverquoteEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.20743 11.28L11.3125 2.17491C12.2423 1.24508 13.7506 1.24508 14.6805 2.17491L15.8966 3.39105C16.8264 4.32088 16.8264 5.82917 15.8966 6.75899L6.7556 15.9C6.34893 16.3067 5.79763 16.5348 5.22207 16.5348H1.47852L1.57266 12.7582C1.58722 12.203 1.81434 11.6731 2.20743 11.28Z",
    stroke: "#F38D33",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1777 3.32812L14.7405 7.88989",
    stroke: "#F38D33",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6973 16.5351H17.1526",
    stroke: "#F38D33",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigOverquoteEdit);
export default __webpack_public_path__ + "static/media/jobconfig-overquote-edit.e9e8f38ffb7ec1df725ff935981e3610.svg";
export { ForwardRef as ReactComponent };